import { PERMISSION_STATUS } from '@bingads-webui-campaign-react/linkedin-utils';
import { LINKING_STAGES } from './constants';

export const getCurrentLinkingStage = (state) => {
  const {
    permissionStatus,
    connectedCompanyPage,
    isReadyToLink,
    isAuthorized,
    needRefreshMemberToken,
  } = state;

  // This is separate flow for member token refresh, it triggered by flag: needRefreshMemberToken
  // MEMBER_TOKEN_INACTIVE => PERMISSION_CHECK
  if (needRefreshMemberToken) {
    return LINKING_STAGES.MEMBER_TOKEN_REFRESH;
  }

  // LINKEDIN_AUTHENTICATION => COMPANY_PAGE_SELECTION => REQUEST_ACCESS => PERMISSION_CHECK
  if (!connectedCompanyPage || permissionStatus === PERMISSION_STATUS.NOT_FOUND) {
    if (!isAuthorized) {
      return LINKING_STAGES.LINKEDIN_AUTHENTICATION;
    }
    // didn't confirm company page yet. including select, agree T&C, acknowledge popup
    if (!isReadyToLink) {
      return LINKING_STAGES.COMPANY_PAGE_SELECTION;
    }

    return LINKING_STAGES.REQUEST_ACCESS;
  }

  // Permission Revoked
  if (permissionStatus === PERMISSION_STATUS.REVOKED) {
    return LINKING_STAGES.REQUEST_ACCESS;
  }

  return LINKING_STAGES.PERMISSION_CHECK;
};
